import React, { useEffect, useState } from "react";
import { isAuthenticated } from "../../Auth/helper";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import LoggedInNavbar from "./loggedInNavbar";
import { getCategoryData } from ".";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Modal from "react-bootstrap/Modal";

// ── tiny API helpers (add these to your frontend index.js / api helpers file) ─
// Or keep them inline here — either works.
//const API = process.env.REACT_APP_API_URL || "http://localhost:8000/api/auth";
const API = process.env.REACT_APP_BACKEND || "https://harikrishnamandir.org/api";

const callToggleLike = async (userId, token, productId) => {
  const res = await fetch(`${API}/user/like/${userId}/${productId}`, {
    method: "POST",
    headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
  });
  return res.json();
};

const callIncrementView = async (productId) => {
  const res = await fetch(`${API}/user/view/${productId}`, {
    method: "POST",
    headers: { Accept: "application/json" },
  });
  return res.json();
};

const CategoryFilter = () => {
  const [data, setData] = useState([]);
  const [engagement, setEngagement] = useState({});
  const { cat, catName } = useParams();
  const navigate = useNavigate();

  // ── Read captionType from query string (?captionType=Hindi) ───────────────
  const location = useLocation();
  const captionType = new URLSearchParams(location.search).get("captionType");
  // captionType will be "Hindi", "English", or null (All Videos)

  const [show, setShow] = useState(false);
  const [modalitem, setmodelitem] = useState({});
  const handleClose = () => setShow(false);

  useEffect(() => {
    let auth = isAuthenticated();
    getCategoryData(auth.user._id, auth.token, { cat, catName })
      .then((dat) => {
        // ── KEY FIX ─────────────────────────────────────────────────────────
        // If captionType param exists, filter down to only those videos.
        // This prevents "None"-labelled videos from leaking into Hindi/English tabs.
        // If no captionType param (All Videos), show everything as before.
        const filtered = captionType
          ? dat.filter((item) => item.captionType === captionType)
          : dat;

        setData(filtered);

        const userId = auth.user._id.toString();
        const initial = {};
        filtered.forEach((item) => {
          initial[item._id] = {
            likeCount: item.likes?.length ?? 0,
            liked:
              item.likes?.some(
                (id) => id === userId || id?._id?.toString() === userId,
              ) ?? false,
            views: item.views ?? 0,
          };
        });
        setEngagement(initial);
      })
      .catch(console.error);
  }, [cat, catName, captionType]);

  // ── Handlers ──────────────────────────────────────────────────────────────
  const handleLike = async (e, productId) => {
    e.stopPropagation();
    const { token, user } = isAuthenticated();
    if (!token) {
      navigate("/signin");
      return;
    }

    setEngagement((prev) => {
      const cur = prev[productId] || { liked: false, likeCount: 0, views: 0 };
      return {
        ...prev,
        [productId]: {
          ...cur,
          liked: !cur.liked,
          likeCount: cur.liked ? cur.likeCount - 1 : cur.likeCount + 1,
        },
      };
    });

    try {
      const result = await callToggleLike(user._id, token, productId);
      setEngagement((prev) => ({
        ...prev,
        [productId]: {
          ...prev[productId],
          liked: result.liked,
          likeCount: result.likeCount,
        },
      }));
    } catch (err) {
      console.error("Like failed:", err);
      setEngagement((prev) => {
        const cur = prev[productId];
        return {
          ...prev,
          [productId]: {
            ...cur,
            liked: !cur.liked,
            likeCount: cur.liked ? cur.likeCount - 1 : cur.likeCount + 1,
          },
        };
      });
    }
  };

  const handleView = async (productId, callback) => {
    try {
      const result = await callIncrementView(productId);
      setEngagement((prev) => ({
        ...prev,
        [productId]: {
          ...(prev[productId] || { liked: false, likeCount: 0 }),
          views: result.views,
        },
      }));
    } catch (err) {
      console.error("View increment failed:", err);
    } finally {
      callback();
    }
  };

  const checkSignedIn = (id, musicid, item, productId) => {
    const auth = isAuthenticated();
    const isSignedin = auth && auth.token && auth.user._id;
    const open = () => {
      if (!isSignedin) {
        navigate("/signin");
        return;
      }
      if (cat === "Videos") navigate(`/player/${id}/${musicid}/?way=${item}`);
      if (cat === "Images")
        navigate(`/displaydata/${id}/${musicid}?id=${item}`);
      if (cat === "Audios")
        navigate(`/audioplayer/${id}/${musicid}/?way=${item}`);
      if (cat === "Speech")
        navigate(`/speechplayer/${id}/${musicid}/?way=${item}`);
      if (cat === "Songs")
        navigate(`/songplayer/${id}/${musicid}/?way=${item}`);
    };
    handleView(productId, open);
  };

  // ── Engagement bar ────────────────────────────────────────────────────────
  const EngagementBar = ({ item, dark = false }) => {
    const eg = engagement[item._id] || { liked: false, likeCount: 0, views: 0 };
    const textColor = dark ? "#fff" : "#555";
    const bgLiked = "#E34607";
    const bgUnliked = dark ? "rgba(255,255,255,0.18)" : "rgba(0,0,0,0.07)";
    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6 }}
      >
        <button
          onClick={(e) => handleLike(e, item._id)}
          title={eg.liked ? "Unlike" : "Like"}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            background: eg.liked ? bgLiked : bgUnliked,
            color: eg.liked ? "#fff" : textColor,
            border: "none",
            borderRadius: 20,
            padding: "4px 10px",
            fontSize: 13,
            cursor: "pointer",
            transition: "all 0.2s",
            fontWeight: 500,
          }}
        >
          <span style={{ fontSize: 15 }}>🫶</span>
          {eg.likeCount > 0 && <span>{eg.likeCount}</span>}
        </button>
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            color: textColor,
            fontSize: 13,
            fontWeight: 500,
          }}
        >
          <span style={{ fontSize: 15 }}>👁️</span>
          <span>{eg.views > 0 ? eg.views : 0}</span>
        </span>
      </div>
    );
  };

  // ── Caption label badge (shown when filtering) ────────────────────────────
  const CaptionBadge = () => {
    if (!captionType) return null;
    return (
      <span
        style={{
          marginLeft: 12,
          fontSize: 12,
          fontWeight: 600,
          backgroundColor: captionType === "Hindi" ? "#fff3cd" : "#cfe2ff",
          color: captionType === "Hindi" ? "#856404" : "#084298",
          padding: "3px 10px",
          borderRadius: 20,
          verticalAlign: "middle",
        }}
      >
        {captionType === "Hindi"
          ? "🇮🇳 Hindi Captioned"
          : "🌐 English Captioned"}
      </span>
    );
  };

  return (
    <>
      <style>{`
        .content-card { transition: transform 0.2s, box-shadow 0.2s; }
        .content-card:hover { transform: translateY(-3px); box-shadow: 0 6px 20px rgba(0,0,0,0.15); }
        .img-card-overlay { position: absolute; bottom: 0; left: 0; right: 0;
          background: linear-gradient(transparent, rgba(0,0,0,0.55));
          padding: 8px 10px; border-radius: 0 0 8px 8px; }
      `}</style>

      <div>
        <LoggedInNavbar />
        <br />
        <div className="container" style={{ width: "90%" }}>
          {/* Header */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "20px",
              gap: "15px",
            }}
          >
            <button
              onClick={() => navigate(-1)}
              style={{
                background: "#E34607",
                color: "white",
                border: "none",
                borderRadius: "8px",
                padding: "10px 15px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              <i className="fas fa-arrow-left"></i>Back
            </button>
            <h2 style={{ color: "#E34607", lineHeight: "34px", margin: 0 }}>
              {cat} / {catName}
              <CaptionBadge />
            </h2>
          </div>

          {/* Empty state */}
          {data.length === 0 && (
            <div
              style={{
                textAlign: "center",
                padding: "60px 20px",
                color: "#888",
              }}
            >
              <i
                className="fas fa-film"
                style={{
                  fontSize: 36,
                  color: "#E34607",
                  opacity: 0.3,
                  marginBottom: 16,
                  display: "block",
                }}
              />
              <p style={{ fontSize: 16 }}>
                No {captionType ? `${captionType} captioned ` : ""}videos found
                in this category.
              </p>
            </div>
          )}

          {/* ── Image grid ──────────────────────────────────────────────── */}
          {cat === "Images" && data.length > 0 ? (
            <div className="row">
              {data.map((item) => (
                <div
                  key={item._id}
                  className="col-6 col-sm-4"
                  style={{ padding: "13px" }}
                >
                  <div
                    style={{ position: "relative", cursor: "pointer" }}
                    className="content-card"
                    onClick={() =>
                      handleView(item._id, () => {
                        setmodelitem(item);
                        setShow(true);
                      })
                    }
                  >
                    <LazyLoadImage
                      src={item.productPathCDN}
                      alt={item.productName}
                      loading="lazy"
                      width="100%"
                      style={{ borderRadius: 8, display: "block" }}
                    />
                    <div className="img-card-overlay">
                      <EngagementBar item={item} dark />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            /* ── Non-image grid ───────────────────────────────────────── */
            <div className="row category-subcategory-container">
              {data.map((item) => (
                <div
                  key={item._id}
                  className="col-sm-4"
                  style={{ padding: "13px" }}
                >
                  <center>
                    <div
                      className="card content-card"
                      style={{
                        flexDirection: "row",
                        cursor: "pointer",
                        backgroundColor: "#f5f5f5",
                        height: "auto",
                        minHeight: 100,
                        padding: "8px",
                        borderRadius: 8,
                      }}
                      onClick={() =>
                        checkSignedIn(
                          item._id,
                          item.productCategory._id,
                          item.productPathCDN,
                          item._id,
                        )
                      }
                    >
                      <LazyLoadImage
                        style={{
                          width: "30%",
                          borderRadius: 6,
                          objectFit: "cover",
                        }}
                        src={item.thumbNailPathCDN}
                        alt={item.productName}
                        loading="lazy"
                      />
                      <div
                        className="card-body"
                        style={{ padding: "6px 10px" }}
                      >
                        <h6 className="card-title" style={{ marginBottom: 4 }}>
                          {item.productName}
                        </h6>
                        <EngagementBar item={item} />
                      </div>
                    </div>
                  </center>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* ── Image lightbox modal ─────────────────────────────────────── */}
        <Modal show={show} onHide={handleClose} size="xl" centered>
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 16 }}>
              {modalitem?.productName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <LazyLoadImage
                src={modalitem?.productPathCDN}
                alt={modalitem?.productName}
                loading="lazy"
                style={{ maxWidth: "100%", borderRadius: 8 }}
              />
            </center>
            {modalitem?.description && (
              <center>
                <p style={{ marginTop: 12, color: "#555" }}>
                  {modalitem.description}
                </p>
              </center>
            )}
            {modalitem?._id && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 12,
                }}
              >
                <EngagementBar item={modalitem} />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </div>
    </>
  );
};

export default CategoryFilter;
